import React from "react"; 
import { Box, Button, List, ListItem, ListItemAvatar, Avatar, ListItemText, Divider, Typography } from "@mui/material";
import LoadingView from "../../components/LoadingView";
import { useOperatori } from "../../service/operatori";
import { CallOutlined, CameraAltOutlined } from "@mui/icons-material";
import { store } from "../../redux/store";
import PhoneNumberDialog from "./PhoneNumberDialog";

const SectionOperatore = ({ idoperatorecantiere = "" }) => {

  const { user } = store.getState();

  const operatori = useOperatori({
    idoperatorecantiere,
    nomecognome: null,
    numerotelefono: null
  });

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      {operatori.isLoading === true ? (
        <List>
          <ListItem alignItems="flex-start">
            <LoadingView />
          </ListItem>
        </List>
      ) : (
        <List>
          <ListItem alignItems="flex-start">
            <ListItemAvatar onClick={() => alert("ciao")}>
              <Avatar alt={operatori.results[0].nomecognome ? operatori.results[0].nomecognome : "..."} src={operatori.results[0].immagine_profilo ? operatori.results[0].immagine_profilo : require("../../assets/images/user-image-default.png")} />
            </ListItemAvatar>
            <ListItemText
              primary={operatori.results[0].nomecognome ? operatori.results[0].nomecognome : "..."}
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {operatori.results[0].numerotelefono ? operatori.results[0].numerotelefono : "..."}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
          <ListItem>
          {operatori.results[0].numerotelefono ? (

            <Button href={"tel:" + operatori.results[0].numerotelefono} variant="outlined" sx={{mb:2, ml: 2}} startIcon={<CallOutlined />}>Chiama Operatore</Button>

          ) : null}
          </ListItem>
          <Divider />
          {user.tipoutente === 'I' ? (

            <>
              <ListItem>
                <Typography sx={{mt:2}}>Modifica dati operatore</Typography>
              </ListItem>
              <ListItem alignItems="flex-start">
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<CameraAltOutlined />}
                >
                  Foto
                  <input
                    type="file"
                    hidden
                  />
                </Button>
                <PhoneNumberDialog 
                idoperatorecantiere={operatori.results[0].idoperatorecantiere ? operatori.results[0].idoperatorecantiere : ""}
                phonenumber={operatori.results[0].numerotelefono ? operatori.results[0].numerotelefono : ""} />
              </ListItem>
              <Divider />
            </>

          ) : null}
        </List>
      )}
    </Box>
  );
};

export default SectionOperatore;
